module.exports = __webpack_public_path__ + "img/sec-13-hi.5f9cceac.svg";